"use client"

import { usePathname } from "next/navigation"
import { SharedHeader } from "@/components/shared-header"
import { SharedFooter } from "@/components/shared-footer"

export function LayoutWrapper({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const bypassChrome = pathname.startsWith('/aigency') || pathname.startsWith('/audit')

  if (bypassChrome) {
    return <>{children}</>
  }

  // Default layout with header/footer
  return (
    <div className="flex h-screen flex-col">
      <SharedHeader />
      <main className="flex-1 overflow-auto">
        <div className="min-h-full">
          {children}
        </div>
      </main>
      <SharedFooter />
    </div>
  )
}